module.exports = __webpack_public_path__ + "assets/img/Travel_Galland.fc7b20bc-ps.jpg";